$(window).on('load resize scroll', function() {

  // Lazy Load Background
  $('[data-lazy-background]').each(function() {
    if ($(window).scrollTop() + $(window).height() > $(this).offset().top) {
      $(this).css('background-image', 'url('+$(this).data('lazy-background')+')');
      $(this).removeAttr('data-lazy-background');
    }
  });

  // Lazy Load Img
  $('[data-lazy-img]').each(function() {
    if ($(window).scrollTop() + $(window).height() > $(this).offset().top) {
      $(this).attr('src', $(this).data('lazy-img'));
      $(this).removeAttr('data-lazy-img');
    }
  });

});

$(window).on('load', function() {

  // Lazy Load Link
  $('[data-lazy-link]').each(function() {
    $(this).attr('href', $(this).data('lazy-link'));
  });

  // Lazy Load Script
  $('[data-lazy-script]').each(function() {
    $(this).attr('src', $(this).data('lazy-script'));
  });

});
